import styled from "styled-components";

import { colorsPalettes, rgba, setElevation, setFontVariant } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { afterTrialBannerModalStyles } from "app/common/after-trial/afterTrialBannerModalStyles";

export const SI_RESTART_TRIAL_MODAL_STYLES = {
    ...afterTrialBannerModalStyles,
    overlay: {
        zIndex: 1130,
    },
} as const;

export const AfterTrialBlockingOverlay = styled(Flex)`
    position: fixed;
    inset: 0;
    z-index: 1120;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
    padding: 16px;
    background-color: ${rgba(colorsPalettes.midnight[300], 0.7)};
`;

export const AfterTrialModalPanel = styled(Flex)`
    position: relative;
    width: 934px;
    max-width: 934px;
    min-height: 460px;
    padding: 20px;
    border: unset;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[0]};
    ${setElevation("Z3")}
`;

export const ModalLayout = styled(Flex)`
    height: 100%;
    gap: 44px;
    align-items: stretch;
    width: 100%;
`;

export const IllustrationPanel = styled(Flex)`
    width: 469px;
    flex-shrink: 0;
    border-radius: 8px;
    background-color: ${colorsPalettes.sky[100]};
    align-items: center;
    justify-content: center;
`;

export const TitleHeading = styled(Text)`
    font-weight: 700;
`;

export const SubtitleText = styled(Text)`
    font-weight: 500;
`;

export const IntroBlock = styled(Stack)`
    margin: 24px 0 48px 0;
`;

export const GetAccessHeading = styled(Text)`
    font-weight: 700;
`;

export const BulletRow = styled(Flex)`
    gap: 4px;
    align-items: center;
`;

export const BenefitsBlock = styled(Stack)`
    margin-bottom: 24px;
`;

export const ContactRow = styled(Flex)`
    margin-bottom: 48px;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
`;

export const ActionsRow = styled(Flex)`
    justify-content: flex-end;
    gap: 12px;
    align-items: flex-end;
`;
